import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BusFront, Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login, error } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(username.trim(), password);
    setBusy(false);
    if (ok) navigate("/dashboard");
  };

  return (
    <div className="min-h-screen auth-bg flex items-center justify-center p-4">
      <div className="w-full max-w-md fade-up">
        <div className="text-center mb-6">
          <div className="mx-auto h-14 w-14 rounded-xl bg-blue-600 flex items-center justify-center shadow-lg shadow-blue-900/40">
            <BusFront className="h-7 w-7 text-white" />
          </div>
          <h1 className="mt-4 text-2xl font-semibold text-white heading">Personenbeförderung</h1>
          <p className="text-sm text-slate-300/80">Verwaltungssystem</p>
        </div>

        <form
          onSubmit={onSubmit}
          className="rounded-md border border-slate-700 bg-slate-900/80 backdrop-blur p-6 shadow-xl"
          data-testid="login-form"
        >
          <h2 className="text-base font-semibold text-slate-100 mb-4 heading">Anmeldung</h2>
          <div className="space-y-4">
            <div>
              <Label htmlFor="username" className="text-slate-200">Benutzername</Label>
              <Input
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="z.B. admin"
                className="mt-1 bg-slate-800 border-slate-700 text-slate-100 placeholder:text-slate-500"
                data-testid="login-username-input"
                autoComplete="username"
                required
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-slate-200">Passwort</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 bg-slate-800 border-slate-700 text-slate-100"
                data-testid="login-password-input"
                autoComplete="current-password"
                required
              />
            </div>
            {error && (
              <div className="text-sm text-red-300 bg-red-950/50 border border-red-900 rounded-md px-3 py-2" data-testid="login-error">
                {error}
              </div>
            )}
            <Button
              type="submit"
              disabled={busy}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white"
              data-testid="login-submit-button"
            >
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Anmelden"}
            </Button>
          </div>
          <div className="mt-5 text-center text-xs text-slate-400">
            Standardzugang: <span className="text-slate-200 font-medium">admin</span> / <span className="text-slate-200 font-medium">admin123</span>
          </div>
        </form>
        <p className="mt-4 text-center text-xs text-slate-400">
          DSGVO-konform · Lokales Hosting · Verschlüsselte Verbindung empfohlen
        </p>
      </div>
    </div>
  );
}
